import React from 'react';
import PropTypes from 'prop-types';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { css } from '@emotion/core';

import config from 'config';

const cardStyles = css`
    .StripeElement {
        font-weight: 300;
        border-radius: ${config('/tailwind/borderRadius/sm')};
        padding: ${config('/tailwind/padding/6')} ${config('/tailwind/padding/4')};
        line-height: 1;
        width: 100%;
        max-width: 100%;
        color: ${config('/tailwind/colors/gray80')};
        background: ${config('/tailwind/colors/white')};
        border: 1px solid ${config('/tailwind/colors/gray20')};
    }

    .StripeElement--focus {
        background: ${config('/tailwind/colors/blue10')};
        border-color: ${config('/tailwind/colors/blue30')};
        outline: none;
    }

    .StripeElement--invalid {
        background: ${config('/tailwind/colors/red10')};
        border-color: ${config('/tailwind/colors/red50')};
        outline: none;
    }
`;

const CardField = ({ name, onChange, onError, stripe }) => (
    <div css={cardStyles}>
        <CardElement
            onChange={async ({ complete }) => {
                if (!complete) return;
                const { error, token } = await stripe.createToken({ name });
                return error ? onError(error) : onChange(token.id);
            }}
            style={{
                base: {
                    fontFamily: config('/tailwind/fonts/sans').join(', '),
                    fontSize: '18px',
                    '::placeholder': {
                        color: config('/tailwind/colors/black30'),
                    },
                },
            }}
            hidePostalCode
        />
    </div>
);

CardField.propTypes = {
    onChange: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    name: PropTypes.string,
    stripe: PropTypes.shape({
        createToken: PropTypes.func,
    }),
};

CardField.defaultProps = {
    name: '',
    stripe: null,
};

export default injectStripe(CardField);
